"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageManager = void 0;
var tslib_1 = require("tslib");
var firestoreLanguageManager_1 = require("./firestoreLanguageManager");
var LanguageManager = /** @class */ (function () {
    function LanguageManager() {
        this.languageManager = new firestoreLanguageManager_1.FirestoreLanguageManager();
    }
    LanguageManager.prototype.setProfilePreferredLanguage = function (userId, preferredLanguage, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languageManager.setProfilePreferredLanguage(userId, preferredLanguage, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LanguageManager.prototype.getProfilePreferredLanguage = function (userId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userPreferredLanguage;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languageManager.getProfilePreferredLanguage(userId, profileId)];
                    case 1:
                        userPreferredLanguage = _a.sent();
                        return [2 /*return*/, userPreferredLanguage];
                }
            });
        });
    };
    LanguageManager.prototype.getAvailableLanguages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languageManager.getAvailableLanguages()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LanguageManager.prototype.getDefaultLanguage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languageManager.getDefaultLanguage()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return LanguageManager;
}());
exports.LanguageManager = LanguageManager;
